import {

  GET_REPORTS_FAIL,
  GET_REPORTS_SUCCESS,
 
  GET_REPORT_DETAIL_SUCCESS,
  GET_REPORT_DETAIL_FAIL,

  GET_AUTH_USER_SUCCESS,
  GET_AUTH_USER_FAIL,
  DELETE_REPORT_SUCCESS

} from "./actionTypes"

const INIT_STATE = {
  reports: [],
  auth: {},
  report: {},
}

const Reports = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REPORTS_SUCCESS:
      return {
        ...state,
        reports: action.payload,
      }

    case GET_REPORTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_AUTH_USER_SUCCESS:
      return {
        ...state,
        auth: action.payload,
      }

    case GET_AUTH_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        report: action.payload,
      }

    case GET_REPORT_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_REPORT_SUCCESS: 
      return {
        ...state,
        reports: state.reports.docs.filter(
          report => report._id !== action.payload.id
        ),
      }

    default:
      return state
  }
}

export default Reports
